// utils/cart.js

// export const getCart = () => {
//   return JSON.parse(localStorage.getItem("cart")) || [];
// };

// export const addToCart = (product) => {
//   const cart = getCart();

//   const existing = cart.find((item) => item.id === product.id);

//   if (existing) {
//     existing.quantity += product.quantity;
//   } else {
//     cart.push(product);
//   }

//   localStorage.setItem("cart", JSON.stringify(cart));
// };

// export const clearCart = () => {
//   localStorage.removeItem("cart");
// };


// utils/cart.js

export const getCart = () => {
  return JSON.parse(localStorage.getItem("cart")) || [];
};

export const saveCart = (cart) => {
  localStorage.setItem("cart", JSON.stringify(cart));
  window.dispatchEvent(new Event("storage")); // 🔥 update navbar
};

export const addToCart = (product) => {
  const cart = getCart();

  const existing = cart.find((item) => item.id === product.id);

  if (existing) {
    existing.quantity += product.quantity;
  } else {
    cart.push(product);
  }

  saveCart(cart);
};

export const removeFromCart = (id) => {
  const cart = getCart().filter((item) => item.id !== id);
  saveCart(cart);
};

export const updateQuantity = (id, type) => {
  const cart = getCart();

  const updated = cart.map((item) => {
    if (item.id === id) {
      if (type === "inc") item.quantity += 1;
      if (type === "dec" && item.quantity > 1) item.quantity -= 1;
    }
    return item;
  });

  saveCart(updated);
};

export const clearCart = () => {
  localStorage.removeItem("cart");

  // 🔥 trigger update
  window.dispatchEvent(new Event("storage"));
};